import axios from 'axios';

const instance = axios.create({
  baseURL: "https://apishareplus.carynhealth.com/staging"
});

export default instance;